import { useMemo } from 'react';
import { Box, CircularProgress, IconButton, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { BsPrinter } from 'react-icons/bs';
import DateRangeSelector from '../../../system/controls/date-range-selector';
import {
  getExecutiveGlassControlClusterSx,
  getExecutiveGlassIconButtonSx,
} from '../../shared/reportSurfaceStyles';

const parseJsonValue = (value) => {
  if (!value) return null;
  if (typeof value === 'object') return value;

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const ReportToolbar = ({ client, profile, loading, title, onPrint }) => {
  const theme = useTheme();

  const clientSettings = useMemo(
    () => parseJsonValue(profile?.clientSettings),
    [profile?.clientSettings]
  );

  const clientName = useMemo(() => (
    client?.name
    || client?.clientname
    || client?.client?.name
    || profile?.clientname
    || profile?.name
    || profile?.title
    || title
    || 'Report'
  ), [client, profile, title]);

  const reportLogo = clientSettings?.reportWorksLogo || clientSettings?.reportwerks_logo || '';
  const reportLogoHref = client?.agency || profile?.agency || '#';
  const controlClusterSx = getExecutiveGlassControlClusterSx(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
        pb: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        {loading ? <CircularProgress size={18} /> : null}
        <Typography color="primary" variant="body1" sx={{ fontWeight: 700 }}>
          {clientName}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', ml: 'auto' }}>
        <Box sx={controlClusterSx}>
          <DateRangeSelector icon={true} />
          {onPrint ? (
            <IconButton
              onClick={onPrint}
              sx={getExecutiveGlassIconButtonSx(theme)}
            >
              <BsPrinter size={20} />
            </IconButton>
          ) : null}
        </Box>

        {reportLogo ? (
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Link href={reportLogoHref} target="_blank" rel="noopener noreferrer">
              <Box
                component="img"
                src={reportLogo}
                alt="ReportWerks"
                sx={{ maxHeight: 34, width: 'auto', display: 'block' }}
              />
            </Link>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default ReportToolbar;
